import { useMemo, useState } from 'react';

import { useGetInvestorFilterOptionsLazyQuery } from '../../graphql/__generated__/GetInvestorFilterOptions';
import {
  allocationColDef,
  createInvestorColDef,
  fillRateColDef,
  indicationColDef,
  investmentAmountColDef,
  issuerColDef,
  offeringTypeColDef,
  offerPriceColDef,
  percentOfDealColDef,
  perfCurrentPercentageColDef,
  perfOneDayPercentageColDef,
  perfOpenPercentageColDef,
  perfSevenDayPercentageColDef,
  perfThirtyDayPercentageColDef,
  pricingDateColDef,
  sectorColDef,
  sellingConcessionAmountColDef,
  sizeInSecuritiesBaseColDef,
  symbolColDef,
} from './column-definitions';
import { ParticipationReportGridColDef } from './types';

export const useCreateColumnDefs = () => {
  const [loadInvestorFilterOptions] = useGetInvestorFilterOptionsLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const investorColDef = useMemo(
    () => createInvestorColDef(loadInvestorFilterOptions),
    [loadInvestorFilterOptions]
  );

  const [colDefs] = useState<ParticipationReportGridColDef[]>([
    pricingDateColDef,
    issuerColDef,
    symbolColDef,
    offeringTypeColDef,
    investorColDef,
    sectorColDef,
    offerPriceColDef,
    allocationColDef,
    indicationColDef,
    sizeInSecuritiesBaseColDef,
    investmentAmountColDef,
    fillRateColDef,
    percentOfDealColDef,
    sellingConcessionAmountColDef,
    perfOpenPercentageColDef,
    perfOneDayPercentageColDef,
    perfSevenDayPercentageColDef,
    perfThirtyDayPercentageColDef,
    perfCurrentPercentageColDef,
  ]);

  return colDefs;
};
